import styled from "@emotion/styled"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

export const ContactWrapper = styled.div`
  border-radius: 2px;
`

export const ContactWrapperAlt = styled.div`
  border-radius: 2px;
  border: 1px solid ${theme.wild.color.nova.transparency.black[20]};
`
